module.exports = __webpack_public_path__ + "img/Cayman-Islands.7102919c.png";